<template>
    <b-modal
        id="modal-sm"
        size="lg"
        title-class="font-18"
        @hidden="resetModal"
        @ok="cancelOrder"
        :ok-title="trans.get('__JSON__.Cancel Order')"
        ok-only
        ok-variant="danger"
        ref="cancel-modal"
        lazy
        >
        <template #modal-header={close}>
            <div class="d-flex justify-content-between w-100">
                <h4 class="mb-0">{{trans.get('__JSON__.Cancel Order')}}</h4>
                <h4 class="mb-0">#{{orderId}}</h4>
            </div>
            <button type="button" aria-label="Close" class="close" @click="close()">&times;</button>
        </template>

        <div class="row">
            <div class="col-12">
                <b-form role="form">
                    <div class="row">
                        <div class="col" v-for="(reason, index) in ((thirdPartyOrder) ? third_party_cancel_reasons : cancel_reasons)" :key="index">
                            <a href="#" @click="onReasonSelect(reason)">
                            <b-card header-class="bg-transparent border-primary" class="border border-primary"
                                :bg-variant="other_selected && reason == 'Other' || reason == cancelled_desc ? 'primary' : 'default'"
                                 body-class="d-flex align-items-center justify-content-center height-100">
                                <h5 class="card-title mt-0" :class="{'text-white': (other_selected && reason == 'Other' || reason == cancelled_desc)}">{{reason}}</h5>
                            </b-card>
                            </a>
                        </div>
                    </div>
                    <b-form-group label="Cancel Description" v-if="other_selected">
                         <b-form-textarea
                            id="textarea"
                            v-model="cancelled_desc"
                            placeholder="Enter something..."
                            rows="3"
                            max-rows="6"
                            ></b-form-textarea>
                    </b-form-group>
                    <b-form-group v-if="!$auth.partner_login && !thirdPartyOrder">
                         <b-form-checkbox
                            id="checkbox-1"
                            switch
                            v-model="is_refundable"
                            class="text-right"
                            name="checkbox-1"
                            size="lg"
                            value="1"
                            unchecked-value="0"
                        >
                        Is Refundable
                        </b-form-checkbox>
                    </b-form-group>
                    <!-- <b-form-group v-if="!$auth.partner_login && cancel_order == true">
                         <b-form-checkbox
                            id="checkbox-2"
                            switch
                            v-model="send_email"
                            class="text-right"
                            name="checkbox-2"
                            size="lg"
                            value="1"
                            unchecked-value="0"
                        >
                        Is Send Mail
                        </b-form-checkbox>
                    </b-form-group> -->
                </b-form>
            </div>
        </div>
    </b-modal>
</template>
<script>
import {order_statuses, success_message} from './../../../Helper/helper'
import config from '../../../config';
import { orderService } from '../../../services';

export default {
    // props :['order-id','cancel_order'],
    props:{
        'order-id':{
            type:String
        },
        'cancel_order':{
            type:Boolean
        },
        'thirdPartyOrder':{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            config: config,
            showModal: false,
            statuses: order_statuses,
            cancelled_desc: '',
            send_email:true,
            is_refundable: false,
            showPopup: false,
            order_id: null,
            cancel_reasons:[
                'Double Order',
                'Promocode not Applied',
                'Order Delayed',
                'Not Responding',
                // 'Too Busy',
                // 'Out of Delivery Area',
                // 'Out of Stock',
                'Other'
            ],
            third_party_cancel_reasons:[
                'receiver not available',
                'returned to seller'
            ],
            other_selected: false,
        }
    },
    mounted(){
        this.cancelOrderPopup()
    },
     methods:{
        resetModal(){
            // this.order_id = null;
            this.is_refundable = false;
            this.$emit('hidden')
        },
        cancelOrderPopup(id,status){
            this.$refs['cancel-modal'].show();
            // this.order_id = id;
        },
        cancelOrder(bvModalEvt){
            bvModalEvt.preventDefault()
            if(this.cancelled_desc == ''){
                this.$toasted.info('Please select cancel reason.');
                return false;
            }
            const data = {orderId:this.orderId,cancelled_desc:this.cancelled_desc, is_refundable:this.is_refundable,send_email:this.send_email};
            orderService.cancelOrder(data)
                .then(response => {
                    if(response.data.code == 200){
                        this.$toasted.success(response.data.message);
                    }else{
                        this.$toasted.error(response.data.message);
                    }
                    this.$refs['cancel-modal'].hide();
                    this.$emit('actionChanged');
                })
        },
        onReasonSelect(reason){
            if(reason !== 'Other'){
                this.cancelled_desc = reason;
                this.other_selected = false;
            }else{
                this.other_selected = true;
                this.cancelled_desc = '';
            }
        }
     }
}
</script>
<style  scoped>
.height-100{
    height: 100px;
}
</style>